import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Shield, Lock, Zap, CheckCircle } from 'lucide-react';
export function FinalCTASection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} id="pricing" className="py-28 px-4 relative overflow-hidden" style={{
    backgroundColor: '#050A14'
  }} data-id="element-32">
      {/* Glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 85% 65% at 50% 50%, rgba(14,165,233,0.1) 0%, rgba(129,140,248,0.05) 45%, transparent 70%)'
    }} data-id="element-33" />

      {/* Grid */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.025]" style={{
      backgroundImage: 'linear-gradient(rgba(14,165,233,1) 1px, transparent 1px), linear-gradient(90deg, rgba(14,165,233,1) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-34" />

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-xs font-black tracking-widest uppercase mb-6 inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{
        color: '#0EA5E9',
        backgroundColor: 'rgba(14,165,233,0.08)',
        border: '1px solid rgba(14,165,233,0.2)'
      }} data-id="element-36">
          TOMA EL CONTROL HOY
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.75,
        delay: 0.1
      }} className="text-4xl md:text-6xl font-black mb-6 leading-tight" style={{
        background: 'linear-gradient(135deg, #F1F5F9 15%, #38BDF8 55%, #818CF8 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }} data-id="element-37">
          Toma el Control del Futuro de Tu Familia
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl mb-12 leading-relaxed" style={{
        color: '#94A3B8'
      }} data-id="element-38">
          No dejes el legado de tu familia al azar o a un sistema escolar
          obsoleto.{' '}
          <strong style={{
          color: '#F1F5F9'
        }} data-id="element-39">
            Conviértete en el estratega que tu hijo necesita.
          </strong>
        </motion.p>

        {/* Pricing card */}
        <motion.div id="pricing-card" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={inView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.65,
        delay: 0.3
      }} className="mb-8 p-8 md:p-10 rounded-2xl w-full" style={{
        backgroundColor: '#0C1628',
        border: '1px solid rgba(14,165,233,0.2)',
        boxShadow: '0 0 60px rgba(14,165,233,0.08)'
      }} data-id="element-40">
          {/* Price */}
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-41">
            <span className="text-2xl font-bold line-through" style={{
            color: '#334155'
          }} data-id="element-42">
              $97
            </span>
            <span className="text-6xl font-black" style={{
            color: '#F59E0B'
          }} data-id="element-43">
              $6.39
            </span>
            <span className="px-3 py-1 rounded-full text-sm font-black" style={{
            backgroundColor: 'rgba(16,185,129,0.15)',
            color: '#10B981',
            border: '1px solid rgba(16,185,129,0.3)'
          }} data-id="element-44">
              -93%
            </span>
          </div>
          <p className="text-sm font-semibold mb-8" style={{
          color: '#475569'
        }} data-id="element-45">
            Precio de lanzamiento - Acceso de por vida
          </p>

          {/* Checklist */}
          <div className="grid sm:grid-cols-2 gap-3 mb-8 text-left" data-id="element-46">
            {['Acceso inmediato a la guía digital', 'Garantía de satisfacción de 30 días'].map((item, i) => <div key={i} className="flex gap-2 text-sm items-center justify-center" style={{
            color: '#CBD5E1'
          }} data-id="element-47">
                <CheckCircle size={15} style={{
              color: '#10B981',
              flexShrink: 0
            }} data-id="element-48" />
                {item}
              </div>)}
          </div>

          {/* CTA */}
          <motion.button onClick={() => {
          ;
          (window as any).fbq?.('track', 'AddToCart', {
            value: 6.39,
            currency: 'USD',
            content_name: 'Arquitectos del Futuro',
            content_ids: ['53858678145299'],
            content_type: 'product'
          });
          window.location.href = 'https://www.novantumnexus.com/cart/53858678145299:1';
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          boxShadow: ['0 0 20px rgba(245,159,11,0.35)', '0 0 50px rgba(245,159,11,0.65)', '0 0 20px rgba(245,159,11,0.35)']
        }} transition={{
          boxShadow: {
            duration: 2.2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="w-full py-5 rounded-full text-xl font-black uppercase tracking-wide cursor-pointer mb-6" style={{
          backgroundColor: '#F59E0B',
          color: '#050A14'
        }} data-id="element-49">
            SÍ, QUIERO ARQUITECTOS DEL FUTURO →
          </motion.button>

          {/* Trust */}
          <div className="flex flex-wrap items-center justify-center gap-5 text-sm" style={{
          color: '#475569'
        }} data-id="element-50">
            <span className="flex items-center gap-1.5" data-id="element-51">
              <Lock size={13} style={{
              color: '#0EA5E9'
            }} data-id="element-52" />
              Pago 100% seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-53">
              <Zap size={13} style={{
              color: '#0EA5E9'
            }} data-id="element-54" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-55">
              <Shield size={13} style={{
              color: '#0EA5E9'
            }} data-id="element-56" />
              Garantía 30 días
            </span>
          </div>
        </motion.div>

        {/* Guarantee */}
      </div>
    </section>;
}